import Banner from "../../components/banner/Banner";
import CoinsTable from "../../components/coinsTable/CoinsTable";

const HomePage = () => {
  return (
    <>
      <Banner />
      <CoinsTable />
    </>
  );
};

export default HomePage;
